import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Observable } from "rxjs";

@Injectable()
export class CacheBustInterceptor implements HttpInterceptor {
  private shouldBustCache = false;

  constructor(private route: ActivatedRoute) {
    this.route.queryParams.subscribe(params => {
      this.shouldBustCache = params['nocache'] === 'true';
    });
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.shouldBustCache) {
      const modifiedUrl = req.url.includes('?') ? `${req.url}&nocache=true` : `${req.url}?nocache=true`;

      const modifiedReq = req.clone({url: modifiedUrl});
      return next.handle(modifiedReq);
    }

    return next.handle(req);
  }
}
